import { watch as w, reactive as M } from "vue";
const S = "//", u = "vue-hubble", N = "*", T = 1e3;
let d;
const b = (e, o, t) => {
  const r = (c) => String.prototype.split.call(o, c).filter(Boolean).reduce((s, n) => s != null ? s[n] : s, e), i = r(/[,[\]]+?/) || r(/[,[\].]+?/);
  return i === void 0 || i === e ? t : i;
}, y = () => d.environment.includes(N) || d.environment.includes(process.env.NODE_ENV), D = () => b(d, ["enableSelectorPicker"], !1), x = (e) => `${S} ${e}`, f = (e, o) => {
  const t = b(e.$options, ["hubble"], b(o, "ctx.setupState.hubble", {}));
  return typeof t == "string" ? t : t.namespace;
}, m = (e, o, t) => {
  if (!t) return "";
  const r = [t], i = d.enableDeepNamespacing, c = f(e, o);
  let s = e, n;
  if (!i)
    r.push(c);
  else
    do {
      n = s.$el.__vnode;
      const l = f(s, n);
      if (l && r.push(l), s.$el === s.$parent.$el) break;
      s = s.$parent;
    } while (s);
  return (d.prefix ? `${d.prefix}--` : "") + r.filter((l) => !!l).reverse().join("--");
}, C = (e) => `${e}`, g = (e, o) => {
  const t = d.enableGroupedSelectors ? `[${u}]` : "";
  switch (o) {
    case "class":
      return `${t}.${e}`;
    case "id":
      return `${t}#${e}`;
    case "attr":
      return `${t}[${e}]`;
    default:
      return `${t}[${e}]`;
  }
}, O = ({ newQuerySelector: e, oldQuerySelector: o, element: t, value: r, parent: i }) => {
  const c = x(e), s = C(e), n = i.childNodes;
  if (A({ element: t, nodes: n, oldQuerySelector: o, parent: i }), r && r.length) {
    const l = document.createComment(c), a = document.createComment(s);
    i.insertBefore(a, t), i.insertBefore(l, t.nextSibling);
  }
}, $ = async (e, { instance: o, arg: t, value: r, oldValue: i }, c) => {
  if (!y()) {
    e.hubbleMouseover && (document.removeEventListener("mouseover", e.hubbleMouseover), e.hubbleMouseover = void 0);
    return;
  }
  if (!e.hubbleMouseover) {
    const p = Math.random().toString(36).substr(2, 11);
    e.hubbleMouseover = E(o, e, p), document.addEventListener("mouseover", e.hubbleMouseover);
  }
  t = t || d.defaultSelectorType;
  const s = e.parentElement, n = m(o, c, r), l = m(o, c, i), a = g(n, t), h = g(l, t);
  if (d.enableComments && s)
    O({ element: e, newQuerySelector: a, oldQuerySelector: h, parent: s, value: r });
  else if (s) {
    const p = s.childNodes;
    A({ element: e, nodes: p, oldQuerySelector: h, parent: s });
  }
  _({ element: e, newQuerySelector: a, newSelector: n, oldSelector: l }), k({
    arg: t,
    element: e,
    newQuerySelector: a,
    newSelector: n,
    oldSelector: l
  });
}, k = ({ arg: e, element: o, oldSelector: t, newSelector: r, newQuerySelector: i }) => {
  switch (e) {
    case "class":
      t && o.classList.remove(t), r && (o.classList.add(r), o.setAttribute(`${u}-selector`, i));
      break;
    case "id":
      o.id = r;
      break;
    case "attr":
      t && o.removeAttribute(t), r && o.setAttributeNode(o.ownerDocument.createAttribute(r));
      break;
    default:
      console.warn(`${e} is not a valid selector type, using attr instead`), t && o.removeAttribute(t), r && o.setAttributeNode(o.ownerDocument.createAttribute(r));
      break;
  }
}, _ = ({ element: e, oldSelector: o, newSelector: t, newQuerySelector: r }) => {
  o && e.removeAttribute(u), e.setAttributeNode(e.ownerDocument.createAttribute(u)), e.setAttribute(`${u}-selector`, t ? r : "");
}, A = ({ nodes: e, element: o, parent: t, oldQuerySelector: r }) => {
  const i = x(r), c = C(r);
  for (let s = 0; s < e.length; s++) {
    const n = e[s + 1], l = e[s - 1];
    e[s] === o && n && n.nodeType === 8 && n.textContent === i && t.removeChild(n), e[s] === o && l && l.nodeType === 8 && l.textContent === c && t.removeChild(l);
  }
}, L = (e) => `'${e}'`, R = (e, o) => {
  const { top: t, left: r, width: i } = e.getBoundingClientRect(), c = e.getAttribute(`${u}-selector`), s = L(c), n = document.createElement("span");
  n.style.position = "fixed", n.style.padding = "6px", n.style.background = "#374151", n.style.borderRadius = "2px", n.style.boxShadow = "0 10px 15px -3px rgba(0,0,0,0.1),0 4px 6px -2px rgba(0,0,0,0.05)", n.style.color = "#A5B4FC", n.style.fontWeight = "400", n.style.userSelect = "all", n.style.zIndex = "99999999", n.style.cursor = "pointer", n.style.fontSize = "16px", n.style.fontFamily = "monospace", n.style.whiteSpace = "nowrap", n.style.textAlign = "center", n.innerText = s, n.setAttribute(`${u}-tooltip-id`, o), n.setAttributeNode(n.ownerDocument.createAttribute(`${u}-tooltip`)), document.body.appendChild(n), n.style.width = `${n.offsetWidth}px`, n.style.left = `${Math.min(
    window.innerWidth - n.offsetWidth,
    Math.max(0, r + i / 2 - n.offsetWidth / 2)
  )}px`, n.style.top = `${Math.min(
    window.outerHeight - n.offsetHeight,
    Math.max(0, t - n.offsetHeight)
  )}px`, n.addEventListener("click", () => {
    document.execCommand("copy"), n.innerText = "Copied!", setTimeout(() => {
      n.innerText = s;
    }, T);
  });
}, U = (e, o) => {
  const t = document.createElement("div"), { top: r, left: i, height: c, width: s } = e.getBoundingClientRect();
  t.style.position = "fixed", t.style.width = `${s}px`, t.style.height = `${c}px`, t.style.left = `${i}px`, t.style.top = `${r}px`, t.style.pointerEvents = "none", t.style.zIndex = "99999998", t.style.background = "rgba(99, 102, 241, .1)", t.style.border = "2px solid #6366F1", t.setAttribute(`${u}-highlight-id`, o), document.body.appendChild(t);
}, E = (e, o, t) => (r) => {
  const { target: i } = r, c = document.querySelector(`[${u}-tooltip-id="${t}"]`), s = document.querySelector(`[${u}-highlight-id="${t}"]`);
  if (!(i === o || i === c || o.contains(i)) || !D())
    return c && c.remove(), s && s.remove();
  c || (R(o, t), U(o, t));
}, B = async (e, { instance: o }, t) => {
  if (!o.hubbleUnwatch && (o.hubbleUnwatch = w(
    d,
    function() {
      o.$forceUpdate();
    },
    { deep: !0 }
  )), !y()) return;
  const r = Math.random().toString(36).substr(2, 11);
  e.hubbleMouseover = E(o, e, r), document.addEventListener("mouseover", e.hubbleMouseover);
}, q = (e, { instance: o }) => {
  e.hubbleMouseover && document.removeEventListener("mouseover", e.hubbleMouseover), o.hubbleUnwatch && o.hubbleUnwatch();
}, H = (e) => (d = e, {
  created: B,
  mounted: $,
  unmounted: q,
  updated: $
}), P = (e) => ({
  all() {
    return [...document.querySelectorAll(`[${u}]`)];
  },
  allMapped() {
    return v(this.all());
  },
  find(o) {
    return [
      ...document.querySelectorAll(`[${u}][${o}]`),
      ...document.querySelectorAll(`[${u}][class*="${o}"]`),
      ...document.querySelectorAll(`[${u}][id*="${o}"]`)
    ];
  },
  findMapped(o) {
    return v(this.find(o));
  },
  first(o) {
    return this.find(o).shift();
  },
  resetOptions() {
    window.$hubble.options = { ...e };
  }
});
function v(e) {
  return [...e].reduce((o, t) => ({
    ...o,
    [t.getAttribute(`${u}-selector`)]: t
  }), {});
}
const W = {
  defaultSelectorType: "attr",
  enableComments: !1,
  enableDeepNamespacing: !0,
  enableGroupedSelectors: !0,
  enableSelectorPicker: !1,
  environment: "test",
  prefix: ""
};
function I(e, o = {}) {
  const t = { ...W, ...o };
  t.environment = [].concat(t.environment), Object.defineProperty(t, "NODE_ENV", { value: process.env.NODE_ENV, writable: !1 });
  let r = M(t);
  e.mixin({
    computed: {
      $hubble: {
        get() {
          return r;
        }
      }
    }
  }), window.$hubble = {
    ...P({ ...t }),
    options: r
  }, e.directive("hubble", H(r));
}
export {
  I as default,
  W as defaultConfig
};
//# sourceMappingURL=vue-hubble.es.js.map
